import format from 'date-fns/format'
import parseDate from 'date-fns/parseISO'

import ru from 'date-fns/locale/ru'
import en from 'date-fns/locale/en-US'

import i18n from "i18next"

export default function (date) {
  if (!date) return ''
  return format(
    parseDate(date),
    'dd MMMM yyyy',
    { locale: i18n.language === 'en' ? en : ru },
  )
}
